<template>
  <b-modal
    id="receiverAccept"
    hide-header
    hide-footer
    modal-class="receiver-accept-modal"
    ignore-enforce-focus-selector=".webim-root"
  >
    <div class="modal__wrapper">
      <div
        class="modal__close"
        @click="() => { hideModal() }"
      >
        <svg
          width="24px"
          height="24px"
        >
          <use xlink:href="#close-modal2" />
        </svg>
      </div>

      <h3 class="receiver-accept__title">
        Пожалуйста, убедитесь, что вы правильно ввели ФИО получателя.
      </h3>
      <p class="receiver-accept__message">
        Внимательно проверьте внесенные данные и исправьте опечатки, если они есть. В случае ошибки вашу посылку могут задержать на таможне.
      </p>
      <div class="receiver-accept__fields-wrap">
        <label
          class="receiver-accept__label"
          :class="{'receiver-accept__label_error': !receiverName.length}"
        >
          <input
            v-model="receiverName"
            class="receiver-accept__input"
            type="text"
            @input="changeReceiverName"
          >
        </label>
      </div>

      <span
        v-if="!receiverName.length"
        class="field__error receiver-accept__field-error"
      >Обязательно для заполнения</span>
      <button
        class="button_vue receiver-accept__btn"
        @click="confirmationReceiverDetails"
      >
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
        >
          <path
            d="M10.25 18.498L3.5 11.748L4.5605 10.6875L10.25 16.3762L20.4395 6.1875L21.5 7.248L10.25 18.498Z"
            fill="#333333"
          />
        </svg>
        Все правильно
      </button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'CalculatorModalReceiverAccept',
  props: {
    receiverDetails: Object,
  },
  data() {
    return {
      receiverName: '',
    };
  },
  mounted() {
    this.receiverName = this.receiverDetails.name;
    this.$bvModal.show('receiverAccept');
  },
  methods: {
    hideModal() {
      this.$bvModal.hide('receiverAccept');
    },
    confirmationReceiverDetails() {
      if (this.receiverName.length) {
        this.$emit('confirmReceiverDetails');
      }
    },
    changeReceiverName() {
      this.$emit('changeReceiverDetails', this.receiverName);
    },
  },
};
</script>

<style lang="scss">
  @import './CalculatorModalReceiverAccept.scss';
</style>
